import axios from "axios";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from "styled-components";
import Loader from "../assets/loaderr.gif";
import  {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setAvatarRoute } from "../utils/APIRoutes";
import { Buffer } from 'buffer';

export default function SetAvatar() {

    const api = "https://api.multiavatar.com/4645646";
    const navigate = useNavigate(); 
    const [avatars, setAvatars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedAvatar, setSelectedAvatar] = useState(undefined);
    const toastOptions = {
        position: "bottom-right",
        autoClose: 8000,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
    }

    useEffect(() => {
        const checkAuthentication = async () => {
            if (!localStorage.getItem('chat-app-user')) {
                navigate('/login');
            }
        };
    
        checkAuthentication();
    }, []);
    const setProfilePicture = async () => {
        if (selectedAvatar === undefined) {
            toast.error ("Please select an avatar", toastOptions);
        } else {
            const user = await JSON.parse(localStorage.getItem("chat-app-user"));
            const { data } = await axios.post(`${setAvatarRoute}/${user._id}`, {
                image: avatars[selectedAvatar],
            });

            console.log(data);

            if(data.isSet) {
                user.isAvatarImageSet = true;
                user.avatarImage = data.image;
                localStorage.setItem("chat-app-user", JSON.stringify(user));
                navigate("/");
            } else {
                toast.error("Error Setting Avatar. Please Try Again", toastOptions)
            }
        }
    }
    useEffect(() => {
        const fetchAvatars = async () => {
            try {
                const data = [];
                for (let i = 0; i < 4; i++) {
                    const response = await axios.get(
                        `${api}/${Math.round(Math.random() * 1000)}`
                    );
                    const buffer = new Buffer(response.data);
                    data.push(buffer.toString("base64"));
                }
                setAvatars(data);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching avatars:", error);
                setIsLoading(false);
            }
        };
    
        fetchAvatars();
    }, []);
    


  return(
  <>
  {
    isLoading ? <Container>
        <img src={Loader} alt="loader" className='loader' />
    </Container> : (
        
    <Container>
        <div className="title-container">
            <h1>
                Pick an Avatar as your Profile Picture
            </h1>
        </div>

            <div className="avatars">
                {
                    avatars.map((avatar, index) => {
                        return (
                            <div
                            key={index} 
                            className={`avatar ${
                                selectedAvatar === index ? "selected" : ""
                                }`}
                            >
                                <img
                                    src={`data:image/svg+xml;base64,${avatar}`} 
                                    alt="avatar" 
                                    onClick={() => setSelectedAvatar(index)} 
                                />
                            </div>
                        );
                    })}
            </div>

            <button className='submit-btn' onClick={setProfilePicture}>
                Set as Profile Picture 
            </button>
    </Container>
    )
  };
    <ToastContainer />
    </>
  );
}




const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    gap: 3rem;
    background-color: #131324;

    .loader {
        max-inline-size: 100%
    }

    .title-container {
        h1{
            color: white;
            font-family: cursive;
        }
    }

    .avatars {
        display: flex;
        gap: 2rem;

        .avatar {
            border: 0.4rem solid transparent;
            padding: 0.4rem;
            border-radius: 5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: 0.5s ease-in-out;
            img {
                height: 6rem; 
            }
        }

        .selected {
            border: 0.4rem solid #4e0eff;

        }
    }

    .submit-btn {
      background-color: #0D0D3E;
      color: white;
      padding: 1rem 2rem;
      border: none;
      font-weight: bold;
      font-family: cursive;
      cursor: pointer;
      border-radius: 0.4rem;
      font-size: 1rem;
      text-transform: uppercase;
      transition: 0.5s ease-in-out;

      &:hover {
        background-color: #4e0eff;
      }
    }
`;